import { ITableColumns } from 'models/table';
import { EIconTypes } from 'constants/Icons';
import React from 'react';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import { getFileExtension, getFileNameFromPath } from 'helpers/image';
import AttachmentPreview from './AttachmentPreview';
import { IAttachment } from './index';
import { StyledAttachmentName } from './AttachmentPreview/styles';

interface IAttachmentsTableColumns {
  handleDelete: (arg: string) => void;
}

export const attachmentsTableColumns = ({
  handleDelete,
}: IAttachmentsTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-abc0-304a6f32f511',
    key: 'path',
    title: 'Name',
    isSortable: false,
    render: (_data, props) => (
      <StyledAttachmentName>
        <AttachmentPreview
          attachment={props as IAttachment}
          extension={getFileExtension(props.path as string)?.toUpperCase()}
        />
        <span>{getFileNameFromPath(props.path as string)}</span>
      </StyledAttachmentName>
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-a345-304a6f32f511',
    key: '',
    title: 'Extension',
    isSortable: false,
    render: (_data, props) => getFileExtension(props.path as string)?.toUpperCase(),
  },
  {
    id: 'f0504ca5-6b32-482d-a269-304a6f32f511',
    key: '',
    width: '100px',
    align: 'center',
    title: 'Action',
    isCenterTableHead: true,
    isSortable: false,
    render: (_data, props) => (
      <Button
        variant={EButtonVariants.outlined}
        icon={EIconTypes.delete}
        onClick={() => handleDelete && handleDelete(props.id)}
      />
    ),
  },
];
